import moment from 'moment';

import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Button, Chip, Divider, Grid, Tooltip, Typography, CircularProgress } from '@material-ui/core';
import { Check, Edit, Computer, InsertDriveFileOutlined, FlashOn, InfoOutlined, Schedule } from '@material-ui/icons';
import DateTimePickerField from './fields/date.time.picker.field';
import RequestAnalysisForm from './analysis/request.analysis.form';
import RequestHearingAnalysisForm from './hearing/request.hearing.analysis.form';
import RequestHearingForm from './hearing/request.hearing.form';
import CheckManualLink from '../solicitations/check.manual.link.component';
import StatusForm from './status.form.component';
import FormField from '../FormField';
import FaciliterCorrectionDropout from '../solicitations/faciliter.correction.dropout.component';
import FaciliterDropout from '../solicitations/faciliter.dropout.component';
import FaciliterReturnToNotStarted from '../solicitations/faciliter.return.to.not.started.component';
import ButtonExtendDeadline from '../solicitations/button.action.extend.deadline.component';
import requestValidator from '../../domain/validators/request.validator';
import ConvertAnalysisNotion from './services/convert.analysis.notion.component';
import UnrevokeButton from './unrevoke.button.component';
import RequestResponsibleComponent from './request.responsible.component';
import AutoVinculoBadge from './auto.vinculo.badge.component';
import TagsForm from '../solicitations/tags.form.component';
import RequestAllServicesDueDate from './request.all.services.due.date.component';
import RequestServicesTimeline from './services/request.services.timeline.component';
import CustomerSubscriptionInfo from '../customer/customer.subscription.info.component';
import PendingSolveButton from './pending/pending.solve.button.component';

import addressService from '../../domain/services/address.service';
import loginService from '../../domain/services/login.service';
import requestHearingAnalysisService from '../../domain/services/request/analysis/request.hearing.analysis.service';
import requestHearingService from '../../domain/services/request/request.hearing.service';
import requestAnalysisService from '../../domain/services/request.analysis.service';
import CorrectionRequestService from './services/correction.request.service.component';
import requestService from '../../domain/services/request/request.service';
import requestNotionService from '../../domain/services/request/notion/request.notion.service';

import datetimeProvider from '../../providers/datetime.provider';

import stepsSolicitation from '../../domain/constant/steps.solicitation.constant';
import { requestServices } from '../../domain/constant/request.services.constant';
import { getAutomaticReviewStepProps } from "../../domain/constant/request.automatic.production.constant";
import RequestInstructionsReviewPetitionIA from '../solicitations/request.instructions.review.petition.ia.component';
import solicitationService from '../../domain/services/solicitation/solicitation.service';
import requestAutomaticReviewValidator from '../../domain/validators/request.production.petition.review.validator';
import { Alert, AlertTitle } from '@material-ui/lab';
import { buildGroupServiceAlert } from '../../domain/services/request/group.service.alert';

import RequestRedoAnalysisButton from './rating/request.redo.analysis.button.component'
import RequestServiceReviewButton from './rating/request.service.review.button.component'

const NOTION_BUTTON_STYLE = { pointerEvents: 'all', height: '32px', fontWeight: 600, marginRight: '10px' };

export default function RequestServiceInformation({
    mainRequestId, setAlert, request, isEdit, isLoading, setRequest, width,
    isSmall, setIsLoading, refresh, setValue, fieldProps
}) {
    const history = useHistory();

    const [isLoadingCheckin, setIsLoadingCheckin] = useState(false);

    const { hearingDateTime } = request;

    const getLocation = async () => {

        if (!navigator.geolocation)
            return setAlert('Não foi possível obter a sua localização para realizar o checkpoint! Habilite a localização no seu navegador e tente novamente.', 'error');

        const location = await addressService.getCityByGeoLocation(setAlert)

        if (!location?.success || !location?.address)
            return setAlert('Não foi possível obter a sua localização para realizar o checkpoint! Habilite a localização no seu navegador e tente novamente.', 'error');

        const address = location.address;
        const cityName = address.city || address.town || address.borough;
        const iso = address['ISO3166-2-lvl4'] || '';
        const stateUf = iso.split('-').pop();

        return {
            cityName,
            stateUf,
            latitude: location.latitude,
            longitude: location.longitude
        };
    };


    const getSamplingInfo = (samplingInfo) => {

        if (!loginService.isInternal() || !samplingInfo || !samplingInfo.concludedAt)
            return null;

        return (
            <Grid item>
                <Typography color='textSecondary' style={{ fontWeight: 600 }}>

                    <Check style={{
                        fontSize: 18, fontWeight: 600, color: 'blue',
                        marginBottom: -3, marginRight: 5,
                    }} />

                    Serviço concluído por amostragem: {moment(samplingInfo?.concludedAt).format('DD/MM/YYYY HH:mm')}

                </Typography>
            </Grid>
        );
    }

    const getFaciliterServiceName = () => {
        const authenticatedUser = loginService.getUserAuthentication();

        const authenticatedFaciliter = (request.members || []).find(m => m.correspondentId == authenticatedUser?.faciliter?.id) || (request.faciliterReviewers || []).find(m => m.correspondentId == authenticatedUser?.faciliter?.id)
        if (authenticatedFaciliter?.faciliterServiceName)
            return authenticatedFaciliter?.faciliterServiceName

        return request.faciliterServiceName
    }

    const getServiceDueDateField = () => {

        const componentBySource = {
            faciliter: () => null,
            internal: () => (
                <Grid item xs={6}>
                    <FormField
                        {...fieldProps}
                        type='datetime'
                        name="dueDate"
                        field="Data e hora de entrega"
                        currentValue={request.dueDate}
                        onChange={(name, value) => {
                            requestService.editRequestAndFields({ id: request.id, dueDate: value })
                                .then(() => setRequest({ ...request, dueDate: value }))
                                .then(() => setAlert('Prazo atualizado com sucesso', 'success'))
                                .catch(error => setAlert(error?.response?.data?.message || 'Não foi possível editar o prazo de entrega', 'error'))
                        }}
                        required
                    />
                </Grid>
            ),
        }

        const componentFunction = componentBySource[loginService.getUserAuthentication().source];

        if (!componentFunction)
            return null;

        return componentFunction();
    }

    const servicesForms = [
        {
            key: 'hearingForm',
            validator: requestHearingService.canViewForm,
            component: () => (
                <RequestHearingForm request={request} />
            )
        },
        {
            key: 'hearingAnalysisForm',
            validator: requestHearingAnalysisService.canViewForm,
            component: () => (
                <RequestHearingAnalysisForm request={request} />
            )
        },
        {
            key: 'requestAnalysisForm',
            validator: requestAnalysisService.canViewFormAnalysis,
            component: () => (
                <RequestAnalysisForm
                    request={request} setAlert={setAlert}
                    isFaciliterPremium={request.isExternalAnalysis}
                />
            )
        },
        {
            key: 'requestNotionForm',
            validator: requestNotionService.canViewForm,
            component: () => {

                if (loginService.isCustomer())
                    return null;

                return <Button
                    variant="contained"
                    color="primary"
                    startIcon={<InsertDriveFileOutlined style={{ fontSize: "16px" }} />}
                    style={NOTION_BUTTON_STYLE}
                    onClick={() => { history.push(`/solicitations/${request.id}/notion`) }}
                >
                    Detalhes do Parecer
                </Button>
            }
        },
    ]

    const serviceButtons = [
        {
            key: 'resolvePending',
            validator: () => request.status == stepsSolicitation.PENDING && loginService.isInternal(),
            component: () => (
                <PendingSolveButton
                    request={request} variant='contained'
                    onFinish={refresh} setAlert={setAlert}
                />
            )
        },
        {
            key: 'faciliterCorrectionDropout',
            validator: () => loginService.isFaciliter() && [stepsSolicitation.NOT_STARTED, stepsSolicitation.IN_PROGRESS, stepsSolicitation.REVIEW].includes(request.status) && request.isInCorrection,
            component: () => (
                <FaciliterCorrectionDropout request={request}
                    setAlert={setAlert} setIsLoading={setIsLoading} />
            )
        },
        {
            key: 'faciliterDropout',
            validator: () => loginService.isFaciliter() && request.status == stepsSolicitation.NOT_STARTED && !request.isInCorrection,
            component: () => (
                <FaciliterDropout request={request} setAlert={setAlert} />
            )
        },
        {
            key: 'faciliterReturnToNotStarted',
            validator: () => loginService.isFaciliter() && request.status === stepsSolicitation.IN_PROGRESS && !request.isInCorrection,
            component: () => (
                <FaciliterReturnToNotStarted request={request} setAlert={setAlert} />
            )
        },
        {
            key: 'convertAnalysisToNotion',
            validator: () => requestValidator.canConvertAnalysisToNotion(request),
            component: () => (
                <ConvertAnalysisNotion mainRequestId={mainRequestId} setAlert={setAlert}
                    isLoading={isLoading} setIsLoading={setIsLoading} />
            )
        },
        {
            key: 'unrevoke',
            validator: () => request.status == stepsSolicitation.REVOKED && !loginService.isFaciliter(),
            component: () => (
                <UnrevokeButton request={request} setAlert={setAlert} refresh={refresh} />
            )
        },
        {
            key: 'serviceCorrection',
            validator: () => requestValidator.canCorrectionService(request),
            component: () => (
                <CorrectionRequestService mainRequestId={mainRequestId} setAlert={setAlert} />
            )
        },
        {
            key: 'redoIaAanalysis',
            validator: () => !!request.hasRedoIaAnalysis && loginService.isInternal(),
            component: () => (
                <RequestRedoAnalysisButton 
                    request={request}
                    setAlert={setAlert}
                    variant='contained'
                />
            )
        },
        {
            key: 'serviceReview',
            validator: () => loginService.isFaciliter() && request.automaticReviewFaciliterUserId == loginService.getUserAuthentication()?.id || loginService.isInternal() && !!request.automaticReviewFaciliterUserId,
            component: () => (
                <RequestServiceReviewButton 
                    request={request}
                    setAlert={setAlert}
                    variant='contained'
                />
            )
        }
    ]

    const getMultipleComponents = (componentsArray = [], size) => {

        const availableItems = componentsArray.filter(item => !item.validator || item.validator(request));

        if (!availableItems.length)
            return null;

        return availableItems.map((item, index) => (
            <Grid item xs={size} key={index}>
                {item.component()}
            </ Grid>
        ))
    }

    const getServiceForms = () => {

        const availableServiceForms = getMultipleComponents(servicesForms);

        if (!availableServiceForms)
            return null;

        return (
            <>

                <Grid item>
                    <Divider />
                </Grid>

                <Grid item container spacing={4}>
                    {availableServiceForms}
                </Grid>

            </>
        )
    }

    const hearingCheckIn = async (locationData) => {

        return requestHearingService.checkIn(request.id, locationData)
            .then(() => setRequest({ ...request, checkIn: new Date().toISOString() }))
            .then(() => setAlert('Checkpoint realizado com sucesso!', 'success'))
            .catch(error => setAlert(error?.response?.data?.message || 'Não foi possível realizar o checkpoint', 'error'));
    }

    const handleConfirmPresence = async () => {

        setIsLoadingCheckin(true);

        return requestHearingService.confirmPresence(request.id)
            .then(() => setRequest({ ...request, hearingConfirmedAt: new Date().toISOString() }))
            .then(() => setAlert('Presença confirmada com sucesso!', 'success'))
            .catch(error => setAlert(error?.response?.data?.message || 'Não foi possível confirmar a presença', 'error'))
            .finally(() => setIsLoadingCheckin(false));
    }

    const validateCheckIn = () => {

        setIsLoadingCheckin(true);

        if (!isInPersonHearing) {
            return hearingCheckIn()
                .finally(() => setIsLoadingCheckin(false));
        }

        getLocation()
            .then((locationData) => {

                if (!locationData?.cityName)
                    return;

                return hearingCheckIn(locationData);

            })
            .finally(() => setIsLoadingCheckin(false));
    }

    const canShowPresenceButton = () => {
        if (!hearingDateTime) return false;
        const dayBeforeHearing = moment(hearingDateTime).subtract(1, 'day').startOf('day');
        return moment().isSameOrAfter(dayBeforeHearing);
    };

    const canShowCheckpointButton = () => {
        if (!hearingDateTime) return false;
        const threeHoursBefore = moment(hearingDateTime).subtract(3, 'hours');
        return moment().isSameOrAfter(threeHoursBefore);
    };

    const isInPersonHearing = request.serviceId == requestServices.structure.hearingInPerson.id;
    const isHearing = [requestServices.structure.hearing.id, requestServices.structure.hearingInPerson.id].includes(request.serviceId);


    const getCorrectionInfo = () => {

        if (!request.isInCorrection)
            return;

        const correctionDate = datetimeProvider.formatDateTime(request.lastCorrectionSendDate, 'DD [de] MMMM [de] YYYY [às] HH:mm');

        return (
            <Tooltip title={`Correção solicitada no dia ${correctionDate}`}>
                <Chip
                    label='É correção'
                    size='small'
                    icon={<Edit style={{ width: 15, color: 'white', marginTop: -3 }} />}
                    style={{
                        borderRadius: 3, fontWeight: 'bold',
                        backgroundColor: 'orange', color: 'white',
                        padding: '0 5px', marginBottom: 10, marginLeft: 4
                    }}
                />
            </Tooltip>
        );
    }

    const getExpressServiceInfo = () => {

        if (!solicitationService.isExpressService(request))
            return;

        return (
            <Tooltip title='Serviço antecipado para o mesmo dia'>
                <Chip
                    label='Serviço Express'
                    size='small'
                    icon={<FlashOn style={{ width: 15, color: 'white' }} />}
                    style={{
                        borderRadius: 3, fontWeight: 'bold',
                        backgroundColor: '#F9C31A', color: 'white',
                        padding: '0 5px', marginBottom: 10, marginLeft: 4
                    }}
                />
            </Tooltip>
        );
    }

    const getAutomaticProductionInfo = () => {

        const isInAutomaticProduction = request?.automaticProductionInfo?.enterStartProductionQueueAt && !request?.automaticProductionInfo?.failedAt
        if (!loginService.isInternal() || !isInAutomaticProduction && !request.analysisWasDevelopedByIa)
            return;

        const label = request.analysisWasDevelopedByIa ? 'Indicação desenvolvida com IA' : 'Desenvolvimento Automático'

        return (
            <Chip
                label={label}
                size='small'
                icon={<Computer style={{ width: 15, color: 'white', marginTop: -3 }} />}
                style={{
                    borderRadius: 3, backgroundColor: 'green',
                    color: 'white', padding: '0 5px',
                    marginBottom: 10, marginLeft: 4
                }}
            />
        );
    }

    const getAutomaticReviewInfo = () => {

        const canShowAutomaticReviewLabel = requestAutomaticReviewValidator.checkToShowAutomaticReviewLabel(request)
        if (!canShowAutomaticReviewLabel)
            return;

        const {
            label,
            description,
            color
        } = getAutomaticReviewStepProps(request)

        return (
            <Tooltip title={description}>
                <Chip
                    label={label}
                    size='small'
                    icon={<Computer style={{ width: 15, color: 'white', marginTop: -3 }} />}
                    style={{
                        borderRadius: 3, backgroundColor: color,
                        color: 'white', padding: '0 5px',
                        marginBottom: 10, marginLeft: 4
                    }}
                />
            </Tooltip>
        );
    }

    const getFaciliterLinkGroupInfo = () => {

        const groupFaciliterLinkServicesIds = request.groupFaciliterLinkServicesIds || []
        if (!groupFaciliterLinkServicesIds.length)
            return;

        return (
            <Tooltip title='Solicitação no fluxo de Indicação de Petição + Petição'>
                <Chip
                    label='Indicação de Petição + Petição'
                    size='small'
                    style={{
                        borderRadius: 3, fontWeight: 'bold',
                        backgroundColor: 'blueviolet', color: 'white',
                        padding: '0 5px', marginBottom: 10, marginLeft: 4
                    }}
                />
            </Tooltip>
        );
    }

    const getFaciliterLinkGroupAlert = () => {

        const groupAlert = buildGroupServiceAlert(request);
        if (!groupAlert) return null;

        return (
            <Grid item>
                <Alert severity="info">
                    <AlertTitle>{groupAlert.title}</AlertTitle>
                    {groupAlert.isHearingGroup ? (
                        <>
                            <b>{groupAlert.heading}</b>
                            <ul style={{ paddingLeft: 20, margin: '6px 0 0 0' }}>
                                {groupAlert.steps.map((step, idx) => (
                                    <li key={idx}><b>{step.label}</b> — {step.body}</li>
                                ))}
                            </ul>
                        </>
                    ) : (
                        <>Após <b>concluir</b> a {groupAlert.first}, o <b>serviço de {groupAlert.second}</b> será automaticamente encaminhado para você elaborar.</>
                    )}
                </Alert>
            </Grid>
        );
    }

    const hasHearingContent = !!hearingDateTime || !!request.hearingConfirmedAt || !!request.checkIn || (isHearing && loginService.isFaciliter());

    return (
        <Grid item>

            {loginService.isInternal() && (
                <Grid item container direction='column' spacing={2} style={{ marginBottom: 20 }}>

                    <Grid item container>

                        {getCorrectionInfo()}

                        <AutoVinculoBadge status={request.status} awaitingFaciliter={request.awaitingFaciliter} isRerouting={request.isRerouting} linkHold={request.linkHold} />

                        {getExpressServiceInfo()}

                        {getAutomaticProductionInfo()}

                        {getAutomaticReviewInfo()}

                        {getFaciliterLinkGroupInfo()}

                    </Grid>

                    <Grid item>
                        <TagsForm
                            tags={request.tags}
                            requestId={request.id}
                            onSave={(field, value) =>
                                setRequest({ ...request, [field]: value })
                            }
                        />
                    </Grid>

                    <Grid item>
                        <RequestResponsibleComponent
                            request={request}
                            refresh={refresh}
                        />
                    </Grid>

                </Grid>
            )}

            <Grid container direction='column' spacing={8}>

                <Grid item container spacing={3}>

                    <Grid item xs={6} style={{ maxWidth: 300 }}>
                        <StatusForm
                            request={request}
                            onRefreshRequest={refresh}
                            setAlert={setAlert}
                            onChange={(name, field) =>
                                setRequest({ ...request, [name]: field })
                            }
                        />
                    </Grid>

                    {getMultipleComponents(serviceButtons)}

                    {request.additionalInformation?.calculationSuggestionDeclinedAt && (
                        <Tooltip title="O cliente optou por não contratar o serviço de cálculo." arrow>
                            <div className="flex items-center gap-1 rounded-md bg-blue-100 px-2 py-1 text-xs m-[6px] text-blue-700 w-fit cursor-help hover:bg-blue-200 transition-colors">
                                <InfoOutlined className='!text-sm color-blue-700' />
                                <Typography variant="body2" className='text-blue-700 font-normal'>
                                    Sem cálculo
                                </Typography>
                            </div>
                        </Tooltip>
                    )}
                </Grid>

                <Grid item>
                    <RequestServicesTimeline
                        request={request}
                        mainRequestId={mainRequestId}
                        isLoading={isLoading} setAlert={setAlert} />
                </Grid>

                {loginService.isInternal() && (
                    <>
                        <Grid
                            item container spacing={6} alignItems='flex-end'
                            xs={isSmall ? 12 : 8}
                        >

                            <Grid item xs={12}>
                                <RequestAllServicesDueDate
                                    mainRequestId={mainRequestId} request={request} refresh={refresh}
                                    width={width} setAlert={setAlert} fieldProps={fieldProps}
                                    setValue={setValue}
                                />
                            </Grid>

                        </Grid>


                        <Grid item>
                            <FormField
                                {...fieldProps}
                                readOnly
                                currentValue={request.customer}
                                field='Cliente'
                            />
                        </Grid>
                    </>
                )}

                <CustomerSubscriptionInfo customerId={request.customerId} />

                {getSamplingInfo(request.samplingInfo)}

                <Grid item container alignItems='flex-end' xs={isSmall ? 12 : 8} spacing={6}>

                    {getServiceDueDateField()}

                    {(loginService.isInternal() || loginService.isFaciliter()) && (
                        <Grid item xs={6}>
                            <DateTimePickerField
                                name="operationalDueDate"
                                label="Prazo de entrega do operacional"
                                value={request.operationalDueDate}
                                values={request}
                                disabled={!loginService.isInternal()}
                                setFieldValue={(name, value) => {
                                    requestService.editRequestAndFields({ id: request.id, operationalDueDate: value })
                                        .then(() => setRequest({ ...request, operationalDueDate: value }))
                                        .then(() => setAlert('Prazo atualizado com sucesso', 'success'))
                                        .catch(error => setAlert(error?.response?.data?.message || 'Não foi possível editar o prazo de entrega do operacional', 'error'))
                                }}
                                required
                                isEdit={isEdit}
                                handleInUtc={false}
                                fieldProps={fieldProps}
                                inputVariant="standard"
                                showIcon={false}
                                titleStyle={{}}
                            />
                        </Grid>
                    )}

                    {loginService.isFaciliter() && (
                        <div style={{ padding: 8 }}>
                            <ButtonExtendDeadline request={request}
                                setFieldValue={setValue} setAlert={setAlert} />
                        </div>
                    )}

                </Grid>

                <Grid item container alignItems='flex-end' spacing={4}>

                    <Grid item xs={6}>
                        <FormField
                            {...fieldProps}
                            readOnly
                            name="faciliterServiceTypeId"
                            field="Tipo do Serviço do Faciliter"
                            currentValue={getFaciliterServiceName()}

                        />
                    </Grid>

                    {loginService.isInternal() && (
                        <Grid item xs={6}>
                            <CheckManualLink
                                request={request}
                                onChange={(name, value) =>
                                    requestService
                                        .editRequestAndFields({ id: request.id, [name]: value })
                                        .then(() => setRequest({ ...request, [name]: value }))
                                        .then(() => setAlert('Vinculação manual atualizada com sucesso', 'success'))
                                        .catch(error => setAlert(error?.response?.data?.message || 'Não foi possível editar a vinculação manual', 'error'))
                                }
                                fieldProps={{ ...fieldProps, titleSize: 14 }}
                            />
                        </Grid>
                    )}

                    {(loginService.isFaciliter() && request.faciliterServiceKey == "refinePetitionIA") &&
                        <Grid item xs={12} style={{ marginTop: 20 }}>
                            <RequestInstructionsReviewPetitionIA openInDialog={true} />
                        </Grid>
                    }

                </Grid>

                {getFaciliterLinkGroupAlert()}

                {hasHearingContent && (() => {
                    const createdAt = request.additionalInformation?.registrationFinishedAt || request.created;
                    const isFaciliter = loginService.isFaciliter();
                    const timelineSteps = [
                        { key: 'created', label: 'Solicitação criada', completed: !!createdAt },
                        { key: 'presence', label: 'Presença Confirmada', completed: !!request.hearingConfirmedAt, datetime: request.hearingConfirmedAt },
                        { key: 'checkin', label: 'Checkpoint', completed: !!request.checkIn, datetime: request.checkIn },
                        { key: 'hearing', label: 'Audiência', completed: false, datetime: hearingDateTime, isTarget: true },
                    ];

                    const formatStepDate = (dt) => {
                        const tz = datetimeProvider.formatDateTimeInTimezone(dt, 'America/Sao_Paulo');
                        return datetimeProvider.formatDateTime(tz, 'DD/MM [às] HH:mm [(BRT)]', true);
                    };

                    return (
                        <Grid item>
                            <div className="py-3">
                                <div className="relative">
                                    {/* Background connecting line */}
                                    <div
                                        className="absolute bg-gray-200"
                                        style={{ top: 8, left: 9, right: 'calc(25% - 9px)', height: 1.5 }}
                                    />

                                    {/* Green progress line segments */}
                                    {timelineSteps.map((step, i) => {
                                        if (i >= timelineSteps.length - 1 || !step.completed) return null;
                                        return (
                                            <div
                                                key={`seg-${i}`}
                                                className="absolute bg-green-500"
                                                style={{ top: 8, left: `calc(${i * 25}% + 9px)`, width: '25%', height: 1.5, zIndex: 1 }}
                                            />
                                        );
                                    })}

                                    {/* Timeline steps */}
                                    <div className="flex relative" style={{ zIndex: 2 }}>
                                        {timelineSteps.map((step) => (
                                            <div key={step.key} className="flex-1 flex flex-col items-start min-w-0">
                                                {/* Circle */}
                                                <div
                                                    className={`w-[18px] h-[18px] rounded-full flex items-center justify-center shrink-0 ${
                                                        step.completed
                                                            ? 'bg-green-500'
                                                            : step.isTarget
                                                            ? 'bg-blue-400'
                                                            : 'bg-gray-300'
                                                    }`}
                                                >
                                                    {step.completed ? (
                                                        <Check style={{ fontSize: 12, color: 'white' }} />
                                                    ) : step.isTarget ? (
                                                        <Schedule style={{ fontSize: 12, color: 'white' }} />
                                                    ) : (
                                                        <div className="w-1 h-1 rounded-full bg-white opacity-70" />
                                                    )}
                                                </div>

                                                {/* Label */}
                                                <span className={`text-[11px] mt-1 text-left leading-tight font-medium ${
                                                    step.completed
                                                        ? 'text-green-700'
                                                        : step.isTarget
                                                        ? 'text-blue-500'
                                                        : 'text-gray-400'
                                                }`}>
                                                    {step.label}
                                                </span>

                                                {/* DateTime */}
                                                {step.datetime && (step.completed || step.isTarget) && (
                                                    <span className={`text-[11px] text-left font-medium mt-0.5 ${
                                                        step.completed ? 'text-green-700' : 'text-gray-500'
                                                    }`}>
                                                        {formatStepDate(step.datetime)}
                                                    </span>
                                                )}

                                                {/* Countdown for hearing */}
                                                {step.isTarget && step.datetime && (
                                                    <>
                                                        <span className="text-[10px] text-gray-400 text-left mt-0.5">
                                                            {datetimeProvider.getTimeDifferenceUntilDate(
                                                                datetimeProvider.getDate(),
                                                                datetimeProvider.formatDateTimeInTimezone(step.datetime, 'America/Sao_Paulo'),
                                                                'Já realizada'
                                                            )}
                                                        </span>
                                                        <span className="text-[9px] text-gray-300 text-left italic">
                                                            Horário de Brasília
                                                        </span>
                                                    </>
                                                )}

                                                {/* Confirm Presence Button */}
                                                {step.key === 'presence' && !step.completed && isHearing && isFaciliter && canShowPresenceButton() && (
                                                    <div className="mt-2">
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            disabled={isLoadingCheckin}
                                                            onClick={handleConfirmPresence}
                                                            style={{ fontSize: 12, padding: '6px 16px', minWidth: 0 }}
                                                        >
                                                            Confirmar Presença
                                                            {isLoadingCheckin && <CircularProgress size={14} style={{ marginLeft: 6 }} />}
                                                        </Button>
                                                    </div>
                                                )}

                                                {/* Check-in Button */}
                                                {step.key === 'checkin' && !step.completed && !!request.hearingConfirmedAt && isHearing && isFaciliter && canShowCheckpointButton() && (
                                                    <div className="mt-2">
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            disabled={isLoadingCheckin}
                                                            onClick={validateCheckIn}
                                                            style={{ fontSize: 12, padding: '6px 16px', minWidth: 0 }}
                                                        >
                                                            Realizar Checkpoint
                                                            {isLoadingCheckin && <CircularProgress size={14} style={{ marginLeft: 6 }} />}
                                                        </Button>
                                                    </div>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                </div>

                            </div>
                        </Grid>
                    );
                })()}
                {getServiceForms()}

            </Grid>
        </Grid >

    );
}
